import React, { useMemo } from 'react'
import { useDrag } from 'react-dnd'

const connectDropTarget = (ret) => ret

const Draggable = React.forwardRef(({
  component: Component,
  dragType,
  id,
  index,
  parentId,
  vertical,
  horizontal,
  sortDisabled,
  onSortStart,
  onSortEnd,

  ...restProps
}, ref) => {
  const [{ isDragging }, connectDragSource, connectDragPreview] = useDrag({
    item: {
      type: dragType,
      itemId: id,
      parentId: parentId,
      index: index,
      onSortEnd: onSortEnd,
      component: Component,
      props: restProps
    },
    canDrag: () => !sortDisabled,
    begin: (monitor) => {
      onSortStart && onSortStart({
        itemId: id,
        parentId,
        index
      })
    },
    end: ({ itemId, parentId, index, onSortEnd }, monitor) => {
      const dropResult = monitor.getDropResult()

      onSortEnd && onSortEnd({
        itemId,
        parentId,
        index,
        droppedOnDroppable: dropResult && dropResult.droppedOnDroppable
      })
    },
    isDragging: (monitor) => id === monitor.getItem().itemId,
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  })

  const sortableProp = useMemo(() => ({
    connectDropTarget,
    connectDragSource,
    connectDragPreview,
    isDragging,
    dragType,
    id,
    parentId,
    index,
    disabled: sortDisabled
  }), [
    connectDragSource,
    connectDragPreview,
    isDragging,
    dragType,
    id,
    parentId,
    index,
    sortDisabled
  ])

  return (
    <Component
      {...restProps}
      ref={ref}
      id={id}
      sortable={sortableProp}
    />
  )
})

Draggable.displayName = 'Draggable'

Draggable.defaultProps = {
  dragType: null
}

export default Draggable
